"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.argon = exports.radon = exports.neon = exports.bromine = exports.helium = exports.citrus = exports.krypton = exports.chlorine = exports.mercury = exports.grey = exports.chaos = exports.order = exports.ansarada = void 0;
exports.ansarada = '#c9fb00';
exports.order = '#ffffff';
exports.chaos = '#07070c';
exports.grey = {
    _100: '#f1f1f1',
    _200: '#e5e1e1',
    _300: '#ddd',
    _400: '#d5d2d2',
    _500: '#c4c2c2',
    _600: '#8e9089',
    _700: '#656662',
};
exports.mercury = {
    _100: '#d1f5fe',
    _200: '#9eeafe',
    _300: '#6be0fd',
    _400: '#00c9fb',
    _500: '#0293b8',
    _600: '#036c88',
    _700: '#053241',
};
exports.chlorine = {
    _100: '#d1fef5',
    _200: '#9efeea',
    _300: '#6bfde0',
    _400: '#00fbc9',
    _500: '#02b794',
    _600: '#03866e',
    _700: '#053d36',
};
exports.krypton = {
    _100: '#d1fee4',
    _200: '#9efec6',
    _300: '#6bfda8',
    _400: '#00fb69',
    _500: '#02b74f',
    _600: '#03863c',
    _700: '#05552a',
};
exports.citrus = {
    _100: '#f5fed1',
    _200: '#eafe9e',
    _300: '#e0fd6b',
    _400: '#c9fb00',
    _500: '#93b703',
    _600: '#6c8606',
    _700: '#323d09',
};
exports.helium = {
    _100: '#fef5d1',
    _200: '#feea9e',
    _300: '#fde06b',
    _400: '#fbc900',
    _500: '#b79303',
    _600: '#866c06',
    _700: '#3d3209',
};
exports.bromine = {
    _100: '#fee4d1',
    _200: '#fec69e',
    _300: '#fda86b',
    _400: '#fb6900',
    _500: '#e86101',
    _600: '#c35203',
    _700: '#552608',
};
exports.neon = {
    _100: '#fed1e4',
    _200: '#fe9ec6',
    _300: '#fd6ba8',
    _400: '#fb0069',
    _500: '#e80162',
    _600: '#c30154',
    _700: '#55052a',
};
exports.radon = {
    _100: '#fed1f5',
    _200: '#fe9eea',
    _300: '#fd6be0',
    _400: '#fb00c9',
    _500: '#b70294',
    _600: '#86036e',
    _700: '#3d0536',
};
exports.argon = {
    _100: '#f5d1fe',
    _200: '#ea9efe',
    _300: '#e95bfd',
    _400: '#c900fb',
    _500: '#9302b8',
    _600: '#6c0388',
    _700: '#320541',
};
//# sourceMappingURL=v1.js.map